<template>
    <div>
        <div class="simple-form flex col-2" v-if="!onlyFile">
            <div class="form-group center">
                <div class="form-label">
                    <label>合同编号</label>
                </div>
                <div class="form-value">
                    <span>{{ invoiceVoucher.contractNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>开票方名称</label>
                </div>
                <div class="form-value">
                    <span>{{ invoiceVoucher.issuerRealName || '' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>受票方公司名称</label>
                </div>
                <div class="form-value">
                    <span>{{ invoiceVoucher.receiverRealComName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>受票方公司编码</label>
                </div>
                <div class="form-value">
                    <span>{{ invoiceVoucher.receiverRealComCode }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>受票方银行名称</label>
                </div>
                <div class="form-value">
                    <span>{{ invoiceVoucher.receiverBankName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>受票方银行账号</label>
                </div>
                <div class="form-value">
                    <span>{{ invoiceVoucher.receiverAcctNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发票类型</label>
                </div>
                <div class="form-value">
                    <span>{{ invoiceVoucher.invoiceTypeText }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发票主体类型</label>
                </div>
                <div class="form-value">
                    <span>{{ invoiceVoucher.invoiceSubjectTypeText }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发票抬头</label>
                </div>
                <div class="form-value">
                    <span>{{ invoiceVoucher.invoiceTitle }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>受票方纳税识别号</label>
                </div>
                <div class="form-value">
                    <span>{{ invoiceVoucher.receiverTaxPayerNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>申请发票金额</label>
                </div>
                <div class="form-value">
                    <span>{{ (parseFloat(invoiceVoucher.amount || 0)).toFixed(2) }}</span>
                    <span>(元)</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label" style="width: 145px">
                    <label>发票方式：</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{ invoiceIssueMethodMap[invoiceVoucher.issueMethod] || '' }}</span>
                    </div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>开票方地址电话</label>
                </div>
                <div class="form-value">
                    <span>{{ invoiceVoucher.issuerAddrTel || '' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>受票方联系人姓名</label>
                </div>
                <div class="form-value">
                    <span>{{ invoiceVoucher.receiverContactName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>受票方联系电话</label>
                </div>
                <div class="form-value">
                    <span>{{ invoiceVoucher.receiverContactTel }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label" style="width: 145px">
                    <label>发票协同状态：</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{ invoiceCollaboStateMap[invoiceVoucher.collaboState] || '' }}</span>
                    </div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发票号</label>
                </div>
                <div class="form-value">
                    <span>{{ invoiceVoucher.actualNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label" style="width: 145px">
                    <label>发票代码：</label>
                </div>
                <div class="form-value">
                    <div class="value">{{ invoiceVoucher.actualCode }}</div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label" style="width: 145px">
                    <label>创建集团名称：</label>
                </div>
                <div class="form-value">
                    <div class="value">{{ invoiceVoucher.creatorRealName || '' }}</div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label" style="width: 145px">
                    <label>创建人名称：</label>
                </div>
                <div class="form-value">
                    <div class="value">{{ invoiceVoucher.creatorStaffName || '' }}</div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label" style="width: 145px">
                    <label>创建方：</label>
                </div>
                <div class="form-value">
                    <div class="value">{{ invoiceCreateRoleMap[invoiceVoucher.creatorRole] || '' }}</div>
                </div>
            </div>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label>附件信息</label>
                </div>
                <div class="form-value">
                    <div class="file-area clearfix" v-if="invoiceVoucher.fileUuid != null && invoiceVoucher.fileUuid != ''">
                        <swb-file-item :fileName="invoiceVoucher.fileExtName" :fileUuid="invoiceVoucher.fileUuid" :fileBrowseUrl="invoiceVoucher.fileBrowseUrl" :fileDownloadUrl="invoiceVoucher.fileBrowseUrl"
                                       :deletable="false"></swb-file-item>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {MsgBox} from '../../app.vues'

    import finacApi from '../../api/finac'

    export default {
        name: 'swb-invoice-voucher-info',
        desc: '发票详情',
        props: {
            id: {
                type: Number,
                default: null
            },
            onlyFile: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                invoiceVoucher: {},
                invoiceCollaboStateMap: getEnumMap('invoiceCollaboState', 'value2text'),
                invoiceIssueMethodMap: getEnumMap('invoiceIssueMethod', 'value2text'),
                invoiceCreateRoleMap: getEnumMap('invoiceCreateRole', 'value2text')
            }
        },
        created: function () {
            this.getInvoiceVoucherInfo();
        },
        methods: {
            getInvoiceVoucherInfo: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                //
                let msgBoxDlg = MsgBox.loading();
                finacApi.getInvoiceVoucherInfo(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type == 'info') {
                        let invoiceVoucher = result.data;
                        //
                        let invoiceTypeInfo = getEnumInfoWith('invoiceType', 'value', invoiceVoucher.invoiceType);
                        if (!Utils.isNoB(invoiceTypeInfo)) {
                            invoiceVoucher.invoiceTypeText = invoiceTypeInfo.text;
                        }
                        let invoiceSubjectTypeInfo = getEnumInfoWith('invoiceSubjectType', 'value', invoiceVoucher.invoiceSubjectType);
                        if (!Utils.isNoB(invoiceSubjectTypeInfo)) {
                            invoiceVoucher.invoiceSubjectTypeText = invoiceSubjectTypeInfo.text;
                        }
                        self.invoiceVoucher = invoiceVoucher;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/invoiceVoucher/InvoiceVoucherInfo.vue